import { remove, uniq } from 'lodash';
import {
  REQUEST_CMS_LIST_SUCCESS,
  REQUEST_CMS_LIST_FAILURE,
  REQUEST_CMS_SUCCESS,
  REQUEST_CMS_FAILURE,
  CREATE_CMS_SUCCESS,
  CREATE_CMS_FAILURE,
  DELETE_CMS_SUCCESS,
  DELETE_CMS_FAILURE
} from '../constants/actionTypes';

const INITIAL_STATE = { ids: [], error: null };

export default function cms(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_CMS_LIST_SUCCESS:
      return {
        ids: action.payload.data.map(data => parseInt(data.id, 10)),
        error: null
      };
    case REQUEST_CMS_LIST_FAILURE:
      return {
        ...state,
        ids: [],
        error: action.payload.message
      };
    case REQUEST_CMS_SUCCESS:
    case CREATE_CMS_SUCCESS:
      return {
        ...state,
        ids: uniq([...state.ids, parseInt(action.payload.data.id, 10)]),
        error: null
      };
    case REQUEST_CMS_FAILURE:
    case CREATE_CMS_FAILURE:
      return {
        ...state,
        error: action.payload.message
      };
    case DELETE_CMS_SUCCESS:
      return {
        ...state,
        ids: remove(state.ids, key => key !== parseInt(action.payload.id, 10)),
        error: null
      };
    case DELETE_CMS_FAILURE:
      return {
        ...state,
        error: action.payload.message
      };
    default:
      return state;
  }
}
